import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "56",
  fill: "none",
  viewBox: "0 0 57 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--_dn-icon_color)",
      "fill-rule": "evenodd",
      d: "M54.03 56v-7.825H38.282c.794-3.625 2.835-7.176 7.974-14.352 5.998-8.345 8.37-14.353 8.37-20.565C54.625 4.72 50.213 0 42.041 0 34.07 0 29.724 4.525 29.724 13.323c0 1.808.198 3.56.396 5.304h9.75c-.133-1.42-.331-3.876-.331-5.953 0-4.07.793-6.277 2.239-6.277 1.379 0 2.172 2.198 2.172 6.277 0 5.693-1.577 9.568-5.998 16.105-7.775 11.57-9.352 15.91-9.352 24.894V56zM13.645 7.111c2.437 0 3.164 4.395 3.164 20.565v1.418c0 16.17-.727 20.564-3.165 20.564H12.52V7.111zM2.375 56h11.336c10.344 0 13.641-6.398 13.641-27.027v-1.168C27.342 7.175 24.055.78 13.712.78H2.374z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }